module.exports = __webpack_public_path__ + "static/media/trophy.8f2c93a7.svg";